import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import './App.css'
import { ENV } from './config';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setUserInfo, setUserStoreInfo } from './redux/userSlice';
import Layout from './layouts/Layout';
import FaroRouteTracker from './observability/FaroRouteTracker';


const Dashboard = lazy(() => import('./pages/dashboard/Dashboard'));
const CornSetup = lazy(() => import('./pages/corn/CornSetup'));
const Invoice = lazy(() => import('./pages/transmission/Invoice'));
const General = lazy(() => import('./pages/general/General'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Pages = lazy(() => import('./pages/apipages/index'));
const CreatePages = lazy(() => import('./pages/apipages/create'));

const Sale = lazy(() => import('./pages/sale/Sale'));




const App = () => {
  const { keycloak, initialized } = useKeycloak();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  // Capture `store` from query string and persist to localStorage



  // useEffect(() => {

  //   // Automatically login if the user is not authenticated
  //   if (initialized && !keycloak.authenticated) {
  //     keycloak.login();
  //   }

  //   // Fetch protected data if the user is authenticated
  //   if (initialized && keycloak && keycloak.authenticated) {
  //     let url = `${ENV.REACT_APP_CENTRAL_AUTH}/api/protected`;
  //     // Fetch data from the protected API endpoint
  //     fetch(url, {
  //       headers: {
  //         Authorization: `Bearer ${keycloak.token}`,
  //       },
  //     })
  //       .then(response => {
  //         if (!response.ok) {
  //           throw new Error('Network response was not ok ' + response.statusText);
  //         }
  //         return response.json();  // Make sure the response is parsed as JSON
  //       })
  //       .then(data => {
  //         if (data.status === '000') {
  //           dispatch(setUserInfo(data.data)); // ← Store in Redux
  //         }

  //       })
  //       .catch(error => {
  //         console.error('Error:', error);
  //         if (error.message.includes('401')) {
  //           keycloak.logout(); // Logout if unauthorized
  //         }
  //       })
  //       .finally(() => setLoading(false));
  //   } else {
  //     setLoading(false); // Stop loading if keycloak is not authenticated or initialized
  //   }
  // }, [keycloak, initialized]);


  useEffect(() => {
    if (!initialized) {
      return; // Wait for Keycloak to initialize
    }

    if (!keycloak.authenticated) {
      keycloak.login();
      return;
    }

    let tokenRefreshInterval;

    const fetchProtectedData = async () => {
      try {
        const url = `${ENV.REACT_APP_CENTRAL_AUTH}/api/protected`;
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const data = await response.json();
        if (data.status === '000') {
          dispatch(setUserInfo(data.data));
          dispatch(setUserStoreInfo(data.store));
        }
      } catch (error) {
        console.error('Error fetching protected data:', error);
        if (error.message.includes('401')) {
          keycloak.logout({
            redirectUri: `${window.location.origin}/`,
          });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProtectedData();

    // Refresh token every 5 minutes
    tokenRefreshInterval = setInterval(() => {
      keycloak.updateToken(300).then((refreshed) => {
        if (refreshed) {
          console.log('Token refreshed');
        } else {
          console.log('Token still valid');
        }
      }).catch(() => {
        console.error('Token refresh failed; logging out');
        keycloak.logout({
          redirectUri: `${window.location.origin}/`,
        });
      });
    }, 300000); // 5 minutes

    return () => {
      if (tokenRefreshInterval) {
        clearInterval(tokenRefreshInterval);
      }
    };
  }, [keycloak, initialized]);


  // If still loading or keycloak not initialized, show a loading spinner or a message
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div>
      {keycloak.authenticated && (
        <Router>
          <FaroRouteTracker />
          <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div className="loader"></div>
          </div>}>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="corn-setup" element={<CornSetup />} />
                <Route path="invoice" element={<Invoice />} />
                <Route path="general" element={<General />} />
                <Route path="pages" element={<Pages />} />
                <Route path="create-pages" element={<CreatePages />} />
                <Route path="edit-page/:id?" element={<CreatePages />} />
                <Route path="page-content/:slug?" element={<Sale />} />
                {/* <Route path="api-list" element={<ApiList />} />
                <Route path="api-form/:id?" element={<ApiForm />} /> */}
                {/* Add more routes as needed */}
                {/* 404 Not Found */}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      )}
    </div>
  );
};

export default App;
